import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var FirstName = /*#__PURE__*/function () {
  function FirstName() {
    _classCallCheck(this, FirstName);
  }

  _createClass(FirstName, null, [{
    key: "isValid",
    value: function isValid(value) {
      var isOnValidLength = value.length >= this.minLength && value.length <= this.maxLength;
      return isOnValidLength;
    }
  }]);

  return FirstName;
}();

_defineProperty(FirstName, "maxLength", 20);

_defineProperty(FirstName, "minLength", 2);